import {sum, upperFirst} from "@pg-mono/nodash";
import {areaFormat, pluralize} from "@pg-mono/string-utils";

import {ILocationGenericSection, ILocationGenericSectionProps, ParagraphType} from "../constants";

export const getCommercialsRoomRangeSectionTexts = (props: ILocationGenericSectionProps): ILocationGenericSection["paragraphs"] => {
    const getGeneralPropertyCountText = (propertiesCount: number) => {
        return `${propertiesCount} ${pluralize(["oferta", "oferty", "ofert"])(propertiesCount)}`;
    };

    const hasCommercialsWithRoomRange = (roomRangeToCheck: number) => {
        const roomRangeRecord = props.region.stats?.properties_commercials_rooms_ranges?.[roomRangeToCheck];
        return !!roomRangeRecord && roomRangeRecord > 0;
    };

    const getRegionCommercialsCountByRoomRange = () => {
        return sum(Object.values(props.region.stats?.properties_commercials_rooms_ranges || {}));
    };

    const hasAnyCommercialsRoomRange = () => {
        return (
            hasCommercialsWithRoomRange(1) ||
            hasCommercialsWithRoomRange(2) ||
            hasCommercialsWithRoomRange(3) ||
            hasCommercialsWithRoomRange(4) ||
            hasCommercialsWithRoomRange(5)
        );
    };

    const getCommercialsGroupedByRoomRange = (roomRange: number) => {
        return props.region.stats?.properties_commercials_rooms_ranges?.[roomRange] || 0;
    };

    const variables = {
        regionNameDeclensionWhere: props.region.name_declension_where,
        propertiesCommercialsRangesAreaMin: props.region.stats?.properties_commercials_ranges_area_min || 0,
        propertiesCommercialsRangesAreaMax: props.region.stats?.properties_commercials_ranges_area_max || 0,
        regionCommercialsCountForSale: getRegionCommercialsCountByRoomRange()
    };

    return hasAnyCommercialsRoomRange()
        ? [
              {
                  type: ParagraphType.TEXT,
                  text: [
                      `Deweloperzy ${props.region.name_declension_where} mają w sprzedaży nowe ${pluralize([
                          `lokal użytkowy`,
                          `lokale użytkowe`,
                          `lokale użytkowe`
                      ])(variables.regionCommercialsCountForSale)}`,
                      variables.propertiesCommercialsRangesAreaMin > 0 &&
                          `${pluralize([
                              `o powierzchni ${areaFormat(variables.propertiesCommercialsRangesAreaMin)}`,
                              `o powierzchniach od ${variables.propertiesCommercialsRangesAreaMin}${
                                  variables.propertiesCommercialsRangesAreaMax > 0 ? ` do ${areaFormat(variables.propertiesCommercialsRangesAreaMax)}` : `m2`
                              }`,
                              `o powierzchniach od ${variables.propertiesCommercialsRangesAreaMin}${
                                  variables.propertiesCommercialsRangesAreaMax > 0 ? ` do ${areaFormat(variables.propertiesCommercialsRangesAreaMax)}` : "m2"
                              }`
                          ])(variables.regionCommercialsCountForSale)}`,
                      `, w tym:`
                  ].filter(Boolean) as string[]
              },
              {
                  type: ParagraphType.LIST,
                  text: [
                      hasCommercialsWithRoomRange(1) && `lokale 1-pokojowe - ${getGeneralPropertyCountText(getCommercialsGroupedByRoomRange(1))}`,
                      hasCommercialsWithRoomRange(2) && `lokale 2-pokojowe - ${getGeneralPropertyCountText(getCommercialsGroupedByRoomRange(2))}`,
                      hasCommercialsWithRoomRange(3) && `lokale 3-pokojowe - ${getGeneralPropertyCountText(getCommercialsGroupedByRoomRange(3))}`,
                      hasCommercialsWithRoomRange(4) && `lokale 4-pokojowe - ${getGeneralPropertyCountText(getCommercialsGroupedByRoomRange(4))}`,
                      hasCommercialsWithRoomRange(5) && `lokale 5-pokojowe i więcej - ${getGeneralPropertyCountText(getCommercialsGroupedByRoomRange(5))}`
                  ].filter(Boolean) as string[]
              }
          ]
        : [
              {
                  type: ParagraphType.TEXT,
                  text: `${upperFirst(variables.regionNameDeclensionWhere)} nie znajdziemy w ofercie sprzedaży nowych lokali użytkowych.`
              }
          ];
};
